import { startTimer, stopTimer } from "./run-timer";
import { fetchBlobImage } from "../../service/image-service";
import { convertBlobToImage } from "../../utils/image-util";

const imageContainer = document.querySelector(".container");
let NR_OF_COLUMNS = 10;
let NR_OF_ROWS = 5;
const ROW_INCREMENT = 1;
const COL_INCREMENT = 1;

function applyDynamicGridStyles() {
  const gap = 10; // 10px
  imageContainer.style.display = "grid";
  imageContainer.style.gridTemplateColumns = `repeat(${NR_OF_COLUMNS}, 1fr)`;
  imageContainer.style.gridTemplateRows = `repeat(${NR_OF_ROWS}, 1fr)`;
  imageContainer.style.gap = `${gap}px`;
  imageContainer.style.width = `calc((50px * ${NR_OF_COLUMNS}) + (${NR_OF_COLUMNS} * ${gap}px))`;
  imageContainer.style.margin = "0 auto";
}

function fillWithPlaceholderImages() {
  for (let column = 0; column < NR_OF_COLUMNS; column+=COL_INCREMENT) {
    for (let row = 0; row < NR_OF_ROWS; row+=ROW_INCREMENT) {
      const img = document.createElement("img");
      img.src = "./50x50.svg";
      img.alt = "Placeholder image";
      img.setAttribute("data-column", column);
      img.setAttribute("data-row", row);
      imageContainer.appendChild(img);
    }
  }
}

function initImageContainer() {
  // clear the image container
  imageContainer.innerHTML = "";
  // styling the image container
  applyDynamicGridStyles();
  // fill the image container with placeholder images
  fillWithPlaceholderImages();
}

// ========================== Fetch Images ========================= //

function fetchImagesWithPromise() {
  const promises = [];
  for (let column = 0; column < NR_OF_COLUMNS; column+=COL_INCREMENT) {
    for (let row = 0; row < NR_OF_ROWS; row+=ROW_INCREMENT) {
      // Here we use the Promise stucture to fetch the image
      const promise = fetchBlobImage().then((blob) => {
         const element = imageContainer.querySelector(
          `img[data-column="${column}"][data-row="${row}"]`,
        );
        element.replaceWith(convertBlobToImage(blob));
      });
      promises.push(promise);
    }
  }
  return Promise.all(promises); // return a promise that resolves when all promises are resolved
}

async function fetchImagesWithAsyncIncorrectly() {
  for (let column = 0; column < NR_OF_COLUMNS; column+=COL_INCREMENT) {
    for (let row = 0; row < NR_OF_ROWS; row+=ROW_INCREMENT) {
      // Here we use the async/await structure to fetch the image
      const blob = await fetchBlobImage();
      const element = imageContainer.querySelector(
        `img[data-column="${column}"][data-row="${row}"]`,
      );
      element.replaceWith(convertBlobToImage(blob));
    }
  }
}

function fetchImagesWithAsyncCorrectly() {
  let promises = [];
  async function getBlobAndReplaceImage(column, row) {
    const blob = await fetchBlobImage();
    const element = imageContainer.querySelector(
      `img[data-column="${column}"][data-row="${row}"]`,
    );
    element.replaceWith(convertBlobToImage(blob));
  }

  for (let column = 0; column < NR_OF_COLUMNS; column += COL_INCREMENT) {
    for (let row = 0; row < NR_OF_ROWS; row += ROW_INCREMENT) {
      promises = [...promises, getBlobAndReplaceImage(column, row)];
    }
  }
  return Promise.all(promises);
}

// ========================== Fetch Images ========================= //

async function fetchImages(method, cols, rows) {
  NR_OF_COLUMNS = cols;
  NR_OF_ROWS = rows;
  initImageContainer();

  // start a counter to measure the time it takes to fetch the images
  const timerId = startTimer();
  console.time("fetchImages");


  if (method === "promise") {
    await fetchImagesWithPromise();
  } else if (method === "async-incorrect") {
    await fetchImagesWithAsyncIncorrectly();
  } else if (method === "async-correct") {
    await fetchImagesWithAsyncCorrectly();
  }

  // stop the counter and log the time it took to fetch the images
  console.timeEnd("fetchImages");
  stopTimer(timerId);
}

initImageContainer();

export { fetchImages, fetchImagesWithPromise, fetchImagesWithAsyncIncorrectly as fetchImagesWithAsync };